import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function QualityGuidePage() {
  return <SeoArticleLayout article={seoArticles[7]} />;
}